const NATIONAL = '(999) 999-9999'

const fits = (value, digits) => value.replace(/\D/g, '').length <= digits

/**
 * libphonenumber groups the number for us, but it answers with its own placeholder template rather
 * than a mask — and it counts the `+` as one of those placeholders. Left as a digit token the mask
 * would refuse to match a `+` there and shunt every digit one place left, so slot zero goes back to
 * being the literal it is. An unrecognised country code has no template at all: nothing to mask.
 */
const international = (value, AsYouType) => {
    const formatter = new AsYouType()

    formatter.input(value)

    const template = formatter.getTemplate()

    return template ? `+${template.slice(1).replace(/x/g, '9')}` : false
}

/**
 * The live template for the phone field, chosen from what the caller has typed so far. `9` is the
 * only digit token @alpinejs/mask knows, so every other character here is a literal it emits for
 * the caller — including the `1`, which is why the plus-one template can be written out in full.
 *
 * A `+` that is not followed by a digit is somebody mid-edit, not a country code, so the national
 * shape takes it: dropping the `1` from `+1 (212) 555-0123` settles back to a New York number
 * rather than being re-read as Moroccan, which is what that string means taken literally.
 *
 * Returning false switches masking off for that keystroke. That is what keeps a pasted foreign
 * number honest — eleven bare digits would otherwise be truncated into a perfectly valid US number
 * nobody can dial, so past the shape's capacity the text is left alone for the validator to refuse.
 *
 * @param {?Function} AsYouType  libphonenumber's formatter, once the chunk carrying it has landed.
 */
export default (value, AsYouType = null) => {
    if (/^\+\D/.test(value)) return fits(value, 10) ? NATIONAL : false

    if (value.startsWith('+1')) return fits(value, 11) ? `+1 ${NATIONAL}` : false

    if (value.startsWith('+')) return AsYouType === null ? false : international(value, AsYouType)

    if (value.startsWith('1')) return fits(value, 11) ? `1 ${NATIONAL}` : false

    return fits(value, 10) ? NATIONAL : false
}
